<template lang="pug">
  .default-pdp-accordion.xs-f-small.max-at-tweak
    .accordion-section(v-if="cmsSettings.accordionSections.titleOne")
      toggle-height
        template(v-slot:top="t")
          button#accordion-button-one.accordion-top.btn-reset(@click="toggleAccordionSection(t, cmsSettings.accordionSections.titleOne, t.val)" :class="{ open: t.val }" aria-controls="accordion-bottom-one" :aria-expanded="!!t.val")
            span.bold.xs-f-xsmall.sm-f-small.max-at-tweak {{ cmsSettings.accordionSections.titleOne }}
            mr-icon.accordion-arrow.xs-f-xxsmall.max-at-tweak(name="caret-rounded" :fill="false" aria-hidden="true")

        template(v-slot:bottom="b")
          .accordion-bottom#accordion-bottom-one(role="region" aria-labelledby="accordion-button-one" :aria-hidden="!!b.val")
            .product-description-info-wrap
              p.product-description.text-color-3.xs-f-small.max-at-tweak {{ product.description }}
              ul.product-info-list.text-color-3.xs-f-small.max-at-tweak
                li.text-color-3.xs-f-small.max-at-tweak(v-for="info in product.prodInfo") {{info}}

    .accordion-section(v-if="cmsSettings.accordionSections.titleTwo && product.ingredientsFactsheet && product.ingredientsFactsheet.length")
      toggle-height
        template(v-slot:top="t")
          button#accordion-button-two.accordion-top.btn-reset(@click="toggleAccordionSection(t, cmsSettings.accordionSections.titleTwo, t.val)" :class="{ open: t.val }" aria-controls="accordion-bottom-two" :aria-expanded="!!t.val")
            span.bold.xs-f-xsmall.sm-f-small.max-at-tweak {{ cmsSettings.accordionSections.titleTwo }}
            mr-icon.accordion-arrow.xs-f-xxsmall.max-at-tweak(name="caret-rounded" :fill="false" aria-hidden="true")

        template(v-slot:bottom="b")
          .accordion-bottom#accordion-bottom-two(role="region" aria-labelledby="accordion-button-two" :aria-hidden="!!b.val")
            IngredientsV2

    .accordion-section(v-if="cmsSettings.accordionSections.titleThree")
      toggle-height
        template(v-slot:top="t")
          button#accordion-button-three.accordion-top.btn-reset(@click="toggleAccordionSection(t, cmsSettings.accordionSections.titleThree, t.val)" :class="{ open: t.val }" aria-controls="accordion-bottom-three" :aria-expanded="!!t.val")
            span.bold.xs-f-xsmall.sm-f-small.max-at-tweak {{ cmsSettings.accordionSections.titleThree }}
            mr-icon.accordion-arrow.xs-f-xxsmall.max-at-tweak(name="caret-rounded" :fill="false" aria-hidden="true")

        template(v-slot:bottom="b")
          .accordion-bottom#accordion-bottom-three(role="region" aria-labelledby="accordion-button-three" :aria-hidden="!!b.val")
            HowToV2

</template>

<script>
  import { mapState } from 'vuex';

  import IngredientsV2 from '@components/PDP/ColorKitPdpV2/ColorKitHeroV2/IngredientsV2';
  import HowToV2 from '@components/PDP/ColorKitPdpV2/ColorKitHeroV2/HowToV2';
  import BoostModule from '@components/PDP/ColorKitPdp/ColorKitHero/BoostModule';

  export default {
    name: "DefaultPdpAccordion",

    components: {
      IngredientsV2,
      HowToV2,
      BoostModule,
    },

    computed: {
      ...mapState('cms', ['cmsSettings']),
      ...mapState('pdp', ['product']),
    },

    methods: {
      toggleAccordionSection(t, title, open) {
        t.toggle();
        const eventName = open ? `DefaultPdpAccordion Section Closed - ${title}` : `DefaultPdpAccordion Section Opened - ${title}`;
        this.trackMREvent(eventName);
      }
    }
  };
</script>

<style scoped lang="stylus">
  .default-pdp-accordion
    .accordion-section
      border-top 1px solid rgba(126, 114, 126, 0.2)
      
      &:last-child
        border-bottom 1px solid rgba(126, 114, 126, 0.2)
      
      .accordion-top
        position relative
        display block
        width 100%
        text-align left
        padding 0.75em 0
        padding-right 3.5em
        
        .accordion-arrow
          position absolute
          right 0.5em
          top 50%
          margin-top -0.25em
          transform rotate(180deg)
          transition transform 350ms ease
          color cta-color-4
          
        &.open
          .accordion-arrow
            transform rotate(0deg)
      
      .accordion-bottom
        padding-bottom 1.75em
        
    .product-description-info-wrap
      padding 0.5em 1em
      
      .product-description
        padding-bottom 1.5em
        
      .product-info-list
        list-style disc
        
        li
          margin-bottom 0.5em
          margin-left 1.25em
          
          &:last-child
            margin-bottom 0
            
    @media mq-desktop-plus
      .accordion-section
        .accordion-top
          padding 1em 0
        
        
</style>
